const QRCodesTransactions = () => {
	return <div>QRCodesTransactions</div>;
};

export default QRCodesTransactions;
